if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /**
         * Toggle edit form
         * Toggle form open/close to edit input data (replaces previously used Form Edit functionality)
         * Expects buttons with classnames: 'change', 'confirm' & 'cancel' within container
         */
        ZZ.FormsToggleItem = function(container) {
            var base = this;

            base.inEditmodus = false;

            base.container = container;

            base.edit = base.container.find(".change");
            base.confirm = base.container.find(".confirm");
            base.cancel = base.container.find(".cancel");

            base.form = base.container.closest("form");

            base.form_elements = base.container.find(".edit-form");

            base.form_original_data = base.form.serialize();

            base.messageHandler = new ZZ.MessageHandler(
                base.container.find("fieldset")
            );

            base.config = $.extend(
                {},
                base._defaultConfig,
                base.container.data()
            );

            let formsToggleItemIgnore = base.container
                .get(0)
                .hasAttribute("data-forms-toggle-item-ignore");

            if (!formsToggleItemIgnore) {
                base.assignListeners();
            }

            return base;
        };

        ZZ.FormsToggleItem.prototype = {
            _defaultConfig: {
                editmodusClassname: "edit-modus",
                errorText:
                    "Er is een fout opgetreden tijdens het opslaan. Probeert u het later nog eens.",
                warningText:
                    "Er staat nog een wijziging open. Klik op opslaan of annuleren om verder te gaan."
            },

            assignListeners: function() {
                var base = this;

                base.edit.on("click", function(e) {
                    e.preventDefault();
                    $(base.container).trigger("edit");
                    //hide only success and warnings message
                    base.messageHandler.hideMessage("warnings");
                });

                base.cancel.on("click", function(e) {
                    e.preventDefault();
                    $(base.container).trigger("ZZ-cancel-edit-toggle-item");
                    base.inEditmodus = false;

                    //hide all already edited form warnings
                    base.messageHandler.hideMessage("all");
                });

                base.form.on("ZZ_form-invalid", function(e) {
                    base.inEditmodus = true;
                });
                base.form.on("ZZ_form-valid", function(e) {
                    base.inEditmodus = false;
                });
                base.form.on("change", function(e) {
                    //if form values are changed add class form-changed
                    if (base.form.serialize() != base.form_original_data) {
                        base.form.addClass("form-changed");
                        base.inEditmodus = true;
                    }
                });
            },

            open: function() {
                this.form_elements.slideDown(200);
                this.container.addClass(this.config.editmodusClassname);
            },

            openFailed: function() {
                this.messageHandler.showMessage(this.config.warningText);
            },

            close: function() {
                this.form_elements.slideUp(200);
                this.container.removeClass(this.config.editmodusClassname);
                this.clearForm();
            },

            /*handleValidationErrors: function (validationArray) {
            var validationObject = new ZZ.FormValidation();
            validationObject.validateMultipleFields(validationArray);
            },*/

            clearForm: function() {
                var base = this,
                    inputs = base.form_elements.find(":input");

                //set form to it original values
                base.form.each(function() {
                    this.reset();
                });
                inputs.trigger("ZZ_input_hidden");
            }
        };
    })(jQuery);
}
